function Scan() {


}

Scan.prototype = new window.vcTemplate();

Scan.prototype.init = function() {
        /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;


    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.visual.find("#div-btn-scan").button().off("click").on("click", function () { me.sendStartScan(); });
        me.validation = new window.vcFormValidation(me.visual, me.visual.find("#div-btn-scan"));
           me.visual.find('.formItem .input').each(function (idx, element) {
       
            me.validation.validate($(element).attr("id"),  me.itemInfo[$(element).attr("id")]);
        });

          me.visual.find('.formItem .input').off("change, keyup").on("change, keyup", function () {
            me.validation.validate($(this).attr("id"), me.itemInfo[$(this).attr("id")]);
        });
        me.visual.find("#btn-refresh-scan-files").button().off("click").on("click", function() { me.sendGetFileList();
            alert("df");
        });
        me.visual.find("#btn-scan-load-list").button().off("click").on("click", function() { me.LoadSingleScanFile(); });
        for (var i = 0; i <= me.JSONScans.length - 1; i++) {
           
            me.createScanSignalList(me.JSONScans[i].ScanDate, me.JSONScans[i].ImportParameter,me.JSONScans[i].ConfigData);
            //me.createScanHeader(me.JSONScans[i].ScanDate, me.JSONScans[i].ImportParameter);
            //me.createScanSignals(me.JSONScans[i].ConfigData);
        }
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};
Scan.prototype.CloneObject = function(src) {
    return Object.assign({}, src);
}

Scan.prototype.sendGetFileList = function() {
      var me = this;
    var scanParameter;
    var updParameter;
    try {
        if (me.visual.find("#btn-refresh-scan-files").button("option", "disabled") === false) {
            scanParameter = me.CloneObject(me.ScanParameterTemplate);
            scanParameter.CardNum = parseInt(me.visual.find("#txtCard").val(), 10);
            scanParameter.StartAddress = parseInt(me.visual.find("#txtAddressStart").val(), 10);
            scanParameter.EndAddress = parseInt(me.visual.find("#txtAddressEnd").val(), 10);
            scanParameter.StartRegister = parseInt(me.visual.find("#txtRegStart").val(), 10);
            scanParameter.EndRegister = parseInt(me.visual.find("#txtRegEnd").val(), 10);
            scanParameter.HighLow = parseInt(me.visual.find("#txtHighLow").val(), 10);
            scanParameter.FunctionCode = parseInt(me.visual.find("#txtFunCode").val(), 10);


            updParameter = me.CloneObject(me.UpdateParameterTemplate);
            updParameter.ScanType = 2;
            updParameter.BLUID = parseInt(me.visual.find("#ddl-unit-dest").val());
            updParameter.BLHID = parseInt(me.visual.find("#ddl-scan-hardware").val());
            updParameter.ScanParameter = scanParameter;
                  window.VisualCoreService.updateData(me.vcvid, me.vcgid,window.getCurrentTimestamp(),0,0,'','',1,2,JSON.stringify(updParameter),
            function() {}
        );



        } else {
            alert("wrong parameter");
        }
    }  catch (ex) {
        me.writeError('sendStartScan', ex);
        return false;
    }
};
Scan.prototype.sendStartScan = function() {
      var me = this;
    var scanParameter;
    var updParameter;
    try {
        if (me.visual.find("#div-btn-scan").button("option", "disabled") === false) {
            scanParameter = me.CloneObject(me.ScanParameterTemplate);
            scanParameter.CardNum = parseInt(me.visual.find("#txtCard").val(), 10);
            scanParameter.StartAddress = parseInt(me.visual.find("#txtAddressStart").val(), 10);
            scanParameter.EndAddress = parseInt(me.visual.find("#txtAddressEnd").val(), 10);
            scanParameter.StartRegister = parseInt(me.visual.find("#txtRegStart").val(), 10);
            scanParameter.EndRegister = parseInt(me.visual.find("#txtRegEnd").val(), 10);
            scanParameter.HighLow = parseInt(me.visual.find("#txtHighLow").val(), 10);
            scanParameter.FunctionCode = parseInt(me.visual.find("#txtFunCode").val(), 10);


            updParameter = me.CloneObject(me.UpdateParameterTemplate);
            updParameter.ScanType = 0;
            updParameter.BLUID = parseInt(me.visual.find("#ddl-unit-dest").val());
            updParameter.BLHID = parseInt(me.visual.find("#ddl-scan-hardware").val());
            updParameter.ScanParameter = scanParameter;
                  window.VisualCoreService.updateData(me.vcvid, me.vcgid,window.getCurrentTimestamp(),0,0,'','',1,2,JSON.stringify(updParameter),
            function() {}
        );



        } else {
            alert("wrong parameter");
        }
    }  catch (ex) {
        me.writeError('sendStartScan', ex);
        return false;
    }
};
Scan.prototype.createScanSignalList = function(scanDate, ImportParameter, ConfigData) {
       var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        var signals = $("<div class='scan-signal-list' style='margin-bottom:30px; width:1865px; float:left; clear:both; border:6px solid red;'></div>");
        signals.append(me.createScanHeader(scanDate, ImportParameter));           
        signals.append(me.createScanSignals(ConfigData));
        me.visual.find("#scan-lists").append(signals);
        return true;
    } catch (ex) {
        me.writeError('createScanSignals', ex);
        return false;
    }
};
Scan.prototype.createScanSignals = function(ConfigData) {
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
//var        editor = new window.UnitAnalogEditor();
//        editor.visual = me.visual;
//        editor.doEvent = function () {};
//        editor.add(ConfigData, false);
        var signals = $("<div class='scan-signals'></div>");
        for (var i = 0; i < ConfigData.length - 1; i++) {
            signals.append($("<div class='scan-signal' style='border: 1px solid black; float:left;'><pre>" + JSON.stringify(ConfigData[i], null,5) + "</pre></div>"));
        }

        return signals;
    } catch (ex) {
        me.writeError('createScanSignals', ex);
        return false;
    }



};
Scan.prototype.createScanHeader = function(scanDate, ImportParameter) {
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        var header = $("<div class='scan-header' style='float:left';></div>");
        var date = $("<div class'scan-header-date'>" + window.moment(scanDate).format("DD.MM.YYYY HH:mm:ss") + "</div>");
        var parameter = $("<div class='scan-header-parameter'><pre>" + JSON.stringify(ImportParameter,null,5) + "</pre></div>");
        header.append(date);
        header.append(parameter);


        return header;
    } catch (ex) {
        me.writeError('createScanHeader', ex);
        return false;
    }

};
 

Scan.prototype.LoadSingleScanFile = function() {

    var me = this;
    var updParameter;
    try {
        if (me.error) {
            return false;
        }
        updParameter = Object.assign(me.UpdateParameterTemplate, updParameter);
        updParameter.ScanType = 1;
            updParameter.BLUID = parseInt(me.visual.find("#ddl-unit-dest").val());

        updParameter.scanParameter = Object.assign(me.FileScanParameterTemplate, updParameter);
        updParameter.scanParameter.FileFilter = $(me.visual.find("#ddl-scan-file-list")).val();
        window.VisualCoreService.updateData(me.vcvid, me.vcgid,window.getCurrentTimestamp(),0,0,'','',1,2,JSON.stringify(updParameter),
            function() {}
        );

        return true;
    } catch (ex) {
        me.writeError('update', ex);
        return false
    }

};


Scan.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#divDone, #divVerify").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


